export default {
      id: "popcorn-usage",
      viewBox: "0 0 511.998 511.998",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#popcorn",
      toString: function () {
        return this.url;
      }
    }